const HpcLogo = () => {
  return (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000.98 42.31">
      <title>HPC Logo</title>
      <defs>
        <style>{'.cls-1{fill:#fff;}'}</style>
      </defs>
      <polygon
        className="cls-1"
        points="23.76 .87 23.76 18.08 6.96 18.08 6.96 .87 0 .87 0 41.44 6.96 41.44 6.96 24.17 23.76 24.17 23.76 41.44 30.72 41.44 30.72 .87 23.76 .87"
      />
      <polygon
        className="cls-1"
        points="82.82 25.39 69.08 3.19 69.08 .87 75.92 .87 86.35 18.84 97.14 .87 103.51 .87 103.51 3.19 89.77 25.1 89.77 41.44 82.82 41.44 82.82 25.39"
      />
      <path
        className="cls-1"
        d="M140.6.87h17.45c8,0,12.23,4.69,12.23,12.46,0,5.27-2.32,9.68-7.13,11.71l7.59,14.08v2.32h-6.84l-8.35-15.59h-8v15.59h-6.95V.87ZM156.77,19.94c4.06,0,6.43-1.97,6.43-6.49s-2.38-6.49-6.43-6.49h-9.22v12.98h9.22Z"
      />
      <path
        className="cls-1"
        d="M206.96,27.7v-13.1c0-9.22,6.2-14.61,15.94-14.61s15.94,5.39,15.94,14.61v13.1c0,9.22-6.2,14.61-15.94,14.61s-15.94-5.39-15.94-14.61M231.88,28.05v-13.79c0-4.35-2.96-7.88-8.99-7.88s-8.98,3.54-8.98,7.88v13.79c0,4.35,2.96,7.88,8.98,7.88s8.99-3.54,8.99-7.88"
      />
      <polygon
        className="cls-1"
        points="272.57 39.12 285.26 20.46 273.55 3.19 273.55 .87 280.62 .87 289.61 15.01 298.99 .87 305.66 .87 305.66 3.19 293.84 20.4 306.65 39.12 306.65 41.44 299.58 41.44 289.43 26.02 279.23 41.44 272.57 41.44 272.57 39.12"
      />
      <rect className="cls-1" x="354.24" y=".87" width="5.07" height="40.56" />
      <polygon
        className="cls-1"
        points="375.71 .88 361.35 .88 361.35 1.72 361.35 1.72 361.35 5.95 361.35 5.95 362.2 5.95 374.1 5.95 375.73 5.95 376.58 5.95 376.58 5.92 376.58 5.95 376.58 1.72 375.71 .88"
      />
      <path
        className="cls-1"
        d="M378.61,3.38v18.44c1.98-1.98,3.09-3.09,5.07-5.07v-8.3c-1.98-1.98-3.09-3.09-5.07-5.07Z"
      />
      <polygon
        className="cls-1"
        points="362.2 18.6 361.35 18.6 361.35 18.6 361.35 22.83 361.35 22.83 361.35 23.67 362.22 23.67 362.22 23.67 375.72 23.67 376.58 22.83 376.58 18.6 362.2 18.6"
      />
      <path className="cls-1" d="M450.69,19.27c-.25-.25-.39-.39-.64-.64h-14.59v5.06h15.23v-4.42Z" />
      <rect className="cls-1" x="428.36" y=".87" width="5.07" height="40.56" />
      <polygon
        className="cls-1"
        points="436.31 5.95 448.21 5.95 449.84 5.95 450.69 5.95 450.69 5.92 450.7 5.95 450.7 1.72 449.82 .88 448.21 .88 448.21 .88 435.47 .88 435.47 1.72 435.46 1.72 435.46 5.95 435.47 5.95 436.31 5.95"
      />
      <path
        className="cls-1"
        d="M457.8,26.38c-1.88-1.88-3-3-4.81-4.81,1.81-1.81,2.92-2.92,4.81-4.81v-8.3c-1.98-1.98-3.09-3.09-5.07-5.07v38.05h5.07v-15.06Z"
      />
      <rect className="cls-1" x="398.41" y="18.63" width="17.26" height="5.07" />
      <rect className="cls-1" x="398.41" y="36.37" width="22.34" height="5.07" />
      <rect className="cls-1" x="391.3" y=".87" width="5.07" height="40.56" />
      <rect className="cls-1" x="398.41" y=".87" width="22.34" height="5.07" />
      <rect className="cls-1" x="472.52" y="18.61" width="17.26" height="5.07" />
      <rect className="cls-1" x="465.41" y=".87" width="5.07" height="40.56" />
      <rect className="cls-1" x="472.52" y=".87" width="22.34" height="5.07" />
      <path className="cls-1" d="M558.83,19.24c-.25-.25-.39-.39-.64-.64h-14.59v5.07h15.23v-4.44Z" />
      <rect className="cls-1" x="536.5" y=".87" width="5.07" height="40.56" />
      <polygon
        className="cls-1"
        points="557.97 .88 556.35 .87 556.35 .87 543.61 .87 543.61 1.72 543.6 1.72 543.6 5.95 543.61 5.95 544.45 5.95 556.35 5.95 557.99 5.95 558.83 5.95 558.83 5.92 558.84 5.95 558.84 1.72 557.97 .88"
      />
      <path
        className="cls-1"
        d="M560.87,3.38h0s0,0,0,0v18.44h0s0,19.61,0,19.61h5.07v-15.07c-1.88-1.88-3-3-4.81-4.81,1.81-1.81,2.92-2.92,4.81-4.81v-3.73h0v-4.57c-1.98-1.98-3.09-3.09-5.07-5.07Z"
      />
      <rect className="cls-1" x="659.09" y=".87" width="5.07" height="40.56" />
      <rect className="cls-1" x="683.46" y=".87" width="5.07" height="40.56" />
      <polygon className="cls-1" points="666.2 13.75 681.43 38.2 681.43 28.61 666.2 4.16 666.2 13.75" />
      <rect className="cls-1" x="740.31" y="18.64" width="17.26" height="5.07" />
      <rect className="cls-1" x="740.31" y="36.36" width="22.33" height="5.07" />
      <rect className="cls-1" x="733.17" y=".87" width="5.14" height="40.56" />
      <rect className="cls-1" x="740.31" y=".87" width="22.33" height="5.07" />
      <polygon className="cls-1" points="523.81 3.75 523.81 38.58 528.89 33.51 528.89 8.82 523.81 3.75" />
      <polygon
        className="cls-1"
        points="506.55 40.59 506.55 36.38 506.55 36.41 506.55 36.36 521.78 36.36 521.78 40.62 520.96 41.44 507.4 41.44 506.55 40.59"
      />
      <polygon
        className="cls-1"
        points="506.55 5.9 506.55 5.93 506.55 1.72 507.4 .87 520.97 .87 521.78 1.68 521.78 5.95 506.55 5.95 506.55 5.9"
      />
      <polygon className="cls-1" points="504.52 3.75 504.52 38.58 499.44 33.51 499.44 8.82 504.52 3.75" />
      <polygon
        className="cls-1"
        points="703.26 36.36 703.25 40.59 704.1 41.44 717.66 41.44 718.49 40.62 718.49 36.36 703.26 36.36"
      />
      <polygon className="cls-1" points="696.15 33.5 701.22 38.56 701.22 3.74 696.15 8.8 696.15 33.5" />
      <polygon className="cls-1" points="720.52 38.58 725.59 33.52 725.59 28.44 720.52 28.44 720.52 38.58" />
      <polygon className="cls-1" points="720.52 3.75 720.52 13.89 725.59 13.89 725.59 8.81 720.52 3.75" />
      <polygon
        className="cls-1"
        points="718.49 5.95 718.49 1.73 717.64 .87 704.08 .87 703.26 1.7 703.26 5.95 718.49 5.95"
      />
      <polygon className="cls-1" points="622.03 41.44 627.11 41.44 627.11 3.75 622.04 8.81 622.03 41.44" />
      <rect className="cls-1" x="629.14" y="22.87" width="15.23" height="5.07" />
      <polygon
        className="cls-1"
        points="643.5 .87 643.5 .87 630.01 .87 630.01 .87 629.14 1.72 629.14 5.95 629.99 5.95 643.52 5.95 644.37 5.95 644.37 5.92 644.38 5.95 644.38 1.72 643.5 .87"
      />
      <polygon className="cls-1" points="651.48 41.44 646.4 41.44 646.4 3.75 651.48 8.81 651.48 41.44" />
      <rect className="cls-1" x="573.39" y=".87" width="5.11" height="40.56" />
      <rect className="cls-1" x="609.77" y=".87" width="5.11" height="40.56" />
      <polygon className="cls-1" points="583.6 .87 580.53 .87 580.53 7.13 591.58 41.44 596.69 41.44 583.6 .87" />
      <polygon className="cls-1" points="604.67 .87 595.21 30.19 597.76 38.12 607.74 7.12 607.74 .87 604.67 .87" />
      <rect className="cls-1" x="911.62" y=".87" width="5.07" height="40.56" />
      <rect className="cls-1" x="918.72" y=".87" width="10.15" height="5.07" />
      <rect className="cls-1" x="899.44" y=".87" width="10.15" height="5.07" />
      <rect className="cls-1" x="863.68" y=".87" width="5.07" height="40.56" />
      <rect className="cls-1" x="888.03" y=".87" width="5.07" height="40.56" />
      <polygon className="cls-1" points="870.78 13.77 886 38.2 886 28.62 870.78 4.19 870.78 13.77" />
      <rect className="cls-1" x="833.7" y="18.66" width="17.25" height="5.07" />
      <rect className="cls-1" x="833.7" y="36.37" width="22.32" height="5.07" />
      <rect className="cls-1" x="826.57" y=".88" width="5.14" height="40.55" />
      <rect className="cls-1" x="833.7" y=".88" width="22.32" height="5.07" />
      <path className="cls-1" d="M993.87,19.26c-.25-.25-.39-.39-.64-.64h-14.58v5.07h15.21v-4.43Z" />
      <rect className="cls-1" x="971.56" y=".87" width="5.07" height="40.56" />
      <polygon
        className="cls-1"
        points="993.01 .88 991.39 .87 991.39 .87 978.66 .87 978.66 1.72 978.66 1.72 978.66 5.94 978.66 5.94 979.5 5.94 991.39 5.94 993.03 5.94 993.87 5.94 993.87 5.91 993.88 5.94 993.88 1.72 993.01 .88"
      />
      <path
        className="cls-1"
        d="M995.91,3.41h0s0,0,0,0v18.43h0s0,19.6,0,19.6h5.07v-15.06c-1.88-1.88-3-3-4.8-4.8,1.8-1.8,2.92-2.92,4.8-4.8v-3.72h0v-4.57c-1.98-1.98-3.09-3.09-5.07-5.07Z"
      />
      <rect className="cls-1" x="942.42" y="18.66" width="17.25" height="5.07" />
      <rect className="cls-1" x="942.42" y="36.37" width="22.32" height="5.07" />
      <rect className="cls-1" x="935.28" y=".88" width="5.14" height="40.55" />
      <rect className="cls-1" x="942.42" y=".87" width="22.32" height="5.07" />
      <polygon
        className="cls-1"
        points="796.56 36.36 796.55 40.59 797.4 41.44 810.96 41.44 811.79 40.62 811.79 36.36 796.56 36.36"
      />
      <polygon className="cls-1" points="789.45 33.5 794.52 38.56 794.52 3.74 789.45 8.8 789.45 33.5" />
      <polygon className="cls-1" points="813.82 38.58 818.89 33.52 818.89 28.44 813.82 28.44 813.82 38.58" />
      <polygon className="cls-1" points="813.82 3.75 813.82 13.89 818.89 13.89 818.89 8.81 813.82 3.75" />
      <polygon
        className="cls-1"
        points="811.78 5.95 811.79 1.73 810.94 .87 797.38 .87 796.55 1.7 796.55 5.95 811.78 5.95"
      />
    </svg>
  );
};

export default HpcLogo;
